import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Card, CardBody, Collapse, Container } from "reactstrap";
import Footer from "../components/partials/Footer";
import Header from "../components/partials/Header";
import { getFaqs } from "../redux/actions/faqActions";

const Faq = (props) => {
  let [activeTab, setActiveTab] = useState(-1);
  useEffect(() => {
    document.body.classList.remove("img-bg");
    window.scrollTo(0, 0);
    props.getFaqs();
  }, []);
  const toggleActive = (tab) => {
    if (activeTab == tab) setActiveTab(-1);
    else setActiveTab(tab);
  };
  var { faqs } = props;
  return (
    <Fragment>
      <Header {...props} heading="FAQ" path={["Home", "FAQ"]}></Header>
      <div className="margin-top-fix text-white-1">
        <h5 className="text-center text-capitalize">
          Have you can find frequently asked questions.
          <br />
          we help you to find the answer.
        </h5>

        <Container className="mt-4 mb-4">
          <div className="custom-accordians">
            {faqs && faqs.length
              ? faqs.map((faq, index) => {
                  return (
                    <div
                      className={`custom-accordian ${
                        activeTab == index && "active"
                      }`}
                    >
                      <Card className="bg-dark-1">
                        <CardBody>
                          <div className="card-content font-2">
                            <div
                              className="d-flex align-items-center accordian-header pointer"
                              onClick={(e) => toggleActive(index)}
                            >
                              <h6
                                className="accordian-title m-0"
                                style={{ fontWeight: 500 }}
                              >
                                {faq.question}
                              </h6>
                              <i
                                className="fa fa-angle-down accordian-icon ms-auto text-red-1"
                                style={{ fontSize: "x-large" }}
                              ></i>
                            </div>
                            <Collapse isOpen={activeTab == index}>
                              <hr />
                              <h6 className="text-lightpurple-1">
                                {faq.answer}
                              </h6>
                            </Collapse>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  );
                })
              : null}
          </div>
        </Container>
      </div>
      <Footer />
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    // auth: state.auth,
    faqs: state.faq.faqs,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getFaqs: () => dispatch(getFaqs()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Faq);
